import React from 'react'
import { Typography } from 'antd'
import { formatCurrency } from '../../utils/currency'

const { Text } = Typography

interface Props {
  label: string
  value: number
  strong?: boolean
}

export const SummaryRow: React.FC<Props> = ({ label, value, strong }) => {
  return (
    <div className="flex justify-between items-center py-1">
      <Text strong={strong}>{label}</Text>
      <Text strong={strong}>{formatCurrency(value)}</Text>
    </div>
  )
}
